import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { massForceDeleteSimpleStepItems } from "../../api/apiSimpleStepItems";
import parseError from "../../utils/parseError";

export function useForceDeleteAllSimpleStepItems() {
    const queryClient = useQueryClient();

    const { mutate: forceDeleteAllItemsMutate, isPending } = useMutation({
        mutationFn: massForceDeleteSimpleStepItems,
        onSuccess: (response) => {
            toast.success(response.message || "Force deleted successfully");
            queryClient.invalidateQueries({ queryKey: ["simple-step-items"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to force delete items");
        },
    });

    return { forceDeleteAllItemsMutate, isPending };
}
